import { render, staticRenderFns } from "./WCheckboxGroup.vue?vue&type=template&id=4c11aca9&scoped=true&"
import script from "./WCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./WCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./WCheckboxGroup.vue?vue&type=style&index=0&id=4c11aca9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c11aca9",
  null
  
)

export default component.exports